export default {"src":"/_next/static/media/caret-down-light.06cdde0a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};